module.exports = __webpack_public_path__ + "static/21-tropical-890bdd83042e0e9a60e86e1d82174e50.jpg";